<template>
  <el-menu
    :default-active="currentMenu?.resourcesCd?.toString()"
    @select="handleSelect"
    :collapse="menuIsCollapse"
    unique-opened
    :class="[
      {
        'nav-menu-responsive': $device.tablet,
        'nav-menu-responsive__show': isShowMobile,
      },
    ]">
    <template v-if="$device.tablet">
      <!-- 언어설정, 로그아웃 등 -->
      <div class="responsive-panel">
        <LanguageSelect />
        <UserInfoButton />
        <LogoutButton />
        <el-button @click="closeMobile" size="mini" circle style="width: 32px; height: 32px">
          <i class="el-icon-close"></i>
        </el-button>
      </div>
    </template>
    <template v-for="menu1 in menuList">
      <el-menu-item
        :key="menu1.resourcesCd"
        v-if="1 == menu1.mlevel && (null == menu1.subMenu || menu1.subMenu.length == 0)"
        :index="String(menu1.resourcesCd)">
        <i class="icon iconfont" :class="menu1.menuIcon"></i>
        <span slot="title">{{ menu1.menuNmLan }}</span>
      </el-menu-item>

      <el-submenu v-else :index="String(menu1.resourcesCd)" :key="menu1.resourcesCd">
        <template slot="title">
          <i class="icon iconfont" :class="menu1.menuIcon"></i>
          <span slot="title">{{ menu1.menuNmLan }}</span>
        </template>

        <el-menu-item :index="String(menu2.resourcesCd)" v-for="menu2 in menu1.subMenu" :key="menu2.resourcesCd">
          <i class="icon iconfont" :class="menu2.menuIcon"></i>
          <span slot="title">{{ menu2.menuNmLan }}</span>
        </el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import UserInfoButton from './UserInfoButton.vue'
import LogoutButton from './LogoutButton.vue'
import LanguageSelect from './LanguageSelect.vue'

export default {
  components: {
    UserInfoButton,
    LogoutButton,
    LanguageSelect,
  },

  computed: {
    ...mapGetters({
      //
      isLogin: 'auth/isLogin',

      menuList: 'menu/menuList',
      menuIsCollapse: 'menu/menuIsCollapse',
      currentMenu: 'menu/currentMenu',

      isShowMobile: 'menu/isShowMobile',
    }),
  },
  watch: {
    '$i18n.locale': {
      handler(val) {
        this.loadMenuList(val)
      },
      immediate: true,
    },
    $route: {
      handler() {
        this.$store.commit('menu/setIsShowMobile', false)
      },
    },
  },
  methods: {
    handleSelect(resourcesCd, resourcesCds) {
      this.$store.commit('menu/setIsShowMobile', false)

      if (this.resourcesCd == resourcesCd) {
        return
      }

      const findMenu = (menuList, targetCd) => {
        for (const menu of menuList) {
          if (menu.resourcesCd == targetCd) {
            return menu
          }

          if (menu.subMenu) {
            const subMenu = findMenu(menu.subMenu, targetCd)

            if (subMenu) {
              return subMenu
            }
          }
        }
      }

      const menu = findMenu(this.menuList, resourcesCd)

      if (!menu) return

      this.$router.push(menu.url).catch(() => {})
    },

    closeMobile() {
      this.$store.commit('menu/setIsShowMobile', false)
    },

    loadMenuList(locale) {
      if (!this.isLogin) {
        return
      }

      this.$store.dispatch('menu/loadMenuList', { locale })
    },
  },
}
</script>

<style scoped>
.el-menu {
  flex-shrink: 0;

  overflow-x: hidden;
  overflow-y: auto;
  border-right: 1px solid var(--color-border) !important;
  background-color: var(--color-bg-card);
}
.el-submenu .el-menu {
  border-right: none !important;
}
.el-menu:not(.el-menu--collapse) {
  width: 220px;
}

.el-menu--collapse {
  width: 59px;
}
.el-submenu .el-menu-item {
  width: 100%;
  min-width: unset;
}

/* 여백 */
span {
  margin-left: 5px;
}

.nav-menu-responsive {
  position: fixed;
  top: 0;
  left: 0;

  width: 100% !important;
  height: 100%;

  background-color: #fff;
  z-index: 1000;
  display: none;
}
.nav-menu-responsive__show {
  display: block;
}

.responsive-panel {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  align-items: center;

  padding: 10px;
  border-bottom: 1px solid var(--color-border);
}
.responsive-panel .el-button + .el-button {
  margin-left: 0;
}

/* Modern active/hover */
.el-menu::v-deep .el-menu-item.is-active {
  background-color: var(--color-primary-light) !important;
  border-right: 3px solid var(--color-primary);
  font-weight: 600;
}
.el-menu::v-deep .el-menu-item:hover {
  background-color: var(--color-bg-page) !important;
}
</style>
